import React, { useContext } from "react";
import { Input } from "components/base/Form";
import CustomerAccount from "components/shared/Customer";
import { Alert } from "components/base/Toast";
import { useModals } from "ModalProvider";
import { validateEmail } from "utils/string";
import { Link } from "react-router-dom";
import ShipmentContext from "../ShipmentContext";

function CustomerInfo({ customer }) {
  const { state, dispatch, updateShipment } = useContext(ShipmentContext);
  const modal = useModals();
  const additionalEmails = (state.extraEmails || "")
    .split(",")
    .map((email) => email.trim())
    .filter(Boolean);
  const validAdditionalEmails = additionalEmails.every(validateEmail);

  function saveAdditionalEmails() {
    if (!validAdditionalEmails) {
      Alert("error", "Please enter valid email addresses separated by commas.");
      return;
    }
    updateShipment({ extraEmails: additionalEmails.join(",") });
  }

  function showSubAccounts() {
    modal.present({
      title: "Sub Accounts",
      children: (
        <div className="space-y-4 text-base">
          <div>
            ⚠️ These accounts will be able to see this shipment in{" "}
            <b>biz.waboba.com</b>
          </div>
          <div>
            <div className="font-semibold">Main Account</div>
            <CustomerAccount className="mt-2" email={customer.user?.email} />
          </div>
          <div>
            <div className="font-semibold">Sub Accounts</div>
            <div className="mt-2 space-y-2">
              {customer.subAccounts.map((c) => (
                <CustomerAccount key={c.id} email={c.user.email} />
              ))}
            </div>
          </div>
        </div>
      ),
    });
  }

  return (
    <div>
      <div className="flex flex-col gap-2">
        <h2>{customer.name}</h2>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-base">
          {customer.user?.email ? (
            <CustomerAccount email={customer.user.email} />
          ) : (
            <span className="text-sm text-red-600">
              {customer.user ? "No email address" : "No linked account"}
            </span>
          )}
          {!customer.user?.email && (
            <Link
              to={`/sales/customers/${customer.id}`}
              target="_blank"
              rel="noreferrer"
              className="text-sm text-sky-600 hover:text-sky-700 hover:underline"
            >
              Manage Customer
            </Link>
          )}
          {customer.subAccounts.length > 0 && (
            <button
              type="button"
              className="text-sm text-sky-600 hover:text-sky-700 hover:underline"
              onClick={showSubAccounts}
            >
              Sub Accounts
            </button>
          )}
        </div>
      </div>

      <div className="text-gray-600 dark:text-gray-300">
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <label className="whitespace-nowrap">Additional Emails(cc):</label>
          <Input
            className={`w-full sm:w-80 ${validAdditionalEmails ? "" : "bg-red-200"}`}
            type="text"
            value={state.extraEmails}
            onChange={(e) =>
              dispatch({
                type: "changeShipment",
                payload: { extraEmails: e.target.value },
              })
            }
            onBlur={saveAdditionalEmails}
            placeholder="seperate by ,"
          />
        </div>
      </div>
    </div>
  );
}

export default CustomerInfo;
